import { useMutation } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";
import { useLocation } from '@reach/router';

const addGetInTouch = (postData) => {
  return http().post(endpoints.forms.getIntTouchLocation, postData);
};

export function useGetInTouchLocation() {
  return useMutation(addGetInTouch, {
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
